// Demo product used for the admin-editor preview (BlockRenderer.tsx, preview/[id]/page.tsx)
// and ProductBlocks.tsx's own admin fallback. Split out of ProductBlocks.tsx so those two
// call sites don't force a static import of the whole 2000+-line ProductBlocks module —
// see blockRegistry.ts, which dynamic-imports ProductBlocks for the actual storefront render.
export const DEMO_PRODUCT = {
    id: 0,
    name: 'Przykładowy Produkt',
    slug: 'przykladowy-produkt',
    description: 'To jest pełny opis przykładowego produktu. Tutaj możesz opisać szczegóły, materiały, wymiary i wszystko, co chcesz przekazać klientowi.',
    short_description: 'Krótkie wprowadzenie do produktu — widoczne na liście lub w sekcji hero.',
    price: 299.99,
    sales_price: 199.99,
    lowest_price_30_days: 249.99,
    stock: 12,
    product_type: 'variable',
    images: [
        { id: 1, path: '/demo_product/test_produkt1.png', is_main: true, order: 0, media_type: 'image' },
        { id: 2, path: '/demo_product/test_product2.png', is_main: false, order: 1, media_type: 'image' },
        { id: 3, path: '/demo_product/test_product3.png', is_main: false, order: 2, media_type: 'image' },
        { id: 4, path: '/demo_product/test_product4.png', is_main: false, order: 3, media_type: 'image' },
    ],
    variants: [
        { id: 1, sku: 'DEMO-S', price: 299.99, sales_price: 199.99, stock: 5, is_default: true, attributes: { Rozmiar: 'S', Kolor: 'Czarny' } },
        { id: 2, sku: 'DEMO-M', price: 299.99, sales_price: null, stock: 7, is_default: false, attributes: { Rozmiar: 'M', Kolor: 'Biały' } },
        { id: 3, sku: 'DEMO-L', price: 299.99, sales_price: null, stock: 0, is_default: false, attributes: { Rozmiar: 'L', Kolor: 'Czarny' } },
    ],
    specifications: [
        { name: '[Osiągi i Napęd]', value: '' },
        { name: 'Moc nominalna', value: '3000 W' },
        { name: 'Moc szczytowa', value: '5600 W' },
        { name: 'Prędkość maksymalna', value: '80 km/h' },
        { name: 'Zasięg', value: 'do 100 km' },
        { name: '[Wymiary i Masa]', value: '' },
        { name: 'Masa', value: '78 kg' },
        { name: 'Wymiary', value: '1850 / 780 / 1150 mm' },
        { name: 'Gwarancja', value: '24 miesiące' },
    ],
};
